import { z } from "zod";
export const Brand = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    persistentId: z.string(),
    name: z.string(),
    description: z.string(),
});
